/**
 * Phase 43 · List of countries supported by Stripe Connect (Express)
 * with human-readable labels. Kept in sync with `PayoutOnboardingCard.jsx`.
 * Any ISO code not present here will render fallback = ISO code alone.
 */
export const COUNTRY_LABELS = {
  AE: 'United Arab Emirates', AT: 'Austria', AU: 'Australia', BE: 'Belgium',
  BG: 'Bulgaria', BR: 'Brazil', CA: 'Canada', CH: 'Switzerland',
  CI: "Côte d'Ivoire", CO: 'Colombia', CR: 'Costa Rica', CY: 'Cyprus',
  CZ: 'Czech Republic', DE: 'Germany', DK: 'Denmark', EE: 'Estonia',
  ES: 'Spain', FI: 'Finland', FR: 'France', GB: 'United Kingdom',
  GH: 'Ghana', GI: 'Gibraltar', GR: 'Greece', HK: 'Hong Kong',
  HR: 'Croatia', HU: 'Hungary', ID: 'Indonesia', IE: 'Ireland',
  IN: 'India', IS: 'Iceland', IT: 'Italy', JP: 'Japan',
  KE: 'Kenya', LI: 'Liechtenstein', LT: 'Lithuania', LU: 'Luxembourg',
  LV: 'Latvia', MT: 'Malta', MX: 'Mexico', MY: 'Malaysia',
  NG: 'Nigeria', NL: 'Netherlands', NO: 'Norway', NZ: 'New Zealand',
  PE: 'Peru', PH: 'Philippines', PL: 'Poland', PT: 'Portugal',
  RO: 'Romania', SA: 'Saudi Arabia', SE: 'Sweden', SG: 'Singapore',
  SI: 'Slovenia', SK: 'Slovakia', SN: 'Senegal', TH: 'Thailand',
  TR: 'Turkey', US: 'United States', UY: 'Uruguay', VN: 'Vietnam',
  ZA: 'South Africa',
};

// Sorted alphabetically for a nicer <select> UX.
export const COUNTRY_OPTIONS = Object.entries(COUNTRY_LABELS)
  .map(([code, name]) => ({ code, name }))
  .sort((a, b) => a.name.localeCompare(b.name));

export const isItaly = (iso) => (iso || '').toUpperCase() === 'IT';
